import React, { useState, useRef, useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import ReactSelect from "react-select";
import { default_article } from "../constants/default";
import ArticleForm from "../../Articles/components/ArticleForm";
import Firebase from "../../../firebasehelper";
import MenuList from "./MenuList";
import SingleValue from "./SingleValue";
import { TerritoryOptions } from "../../../Constants/brand";
import { useHistory } from "react-router-dom";

const AddArticleModal = ({ onAdd, brand }) => {
  const [isPostable, setIsPostable] = useState(false);
  const dismissElement = useRef();
  const history = useHistory();
  const [article, setArticle] = useState(default_article);
  const [events, setEvents] = useState([]);
  const [products, setProducts] = useState([]);
  const [liveTasks, setLiveTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toMembers, setToMembers] = useState(true);
  const [isPublic, setIsPublic] = useState(true);
  const [toReferrals, setToReferrals] = useState(true);
  const [territoryToPublish, setTerritoryToPublish] = useState({
    value: "All",
    label: "All",
  });
  // const brand = useSelector((state) => state.brand);
  useEffect(() => {
    if (brand) {
      if (brand.name) {
        Firebase.getAllEvents(brand.name, (events) => setEvents(events)); // get Events
        Firebase.getEcoPackages((products) => {
          // get products
          let bPckgs_ids = Object.keys(products);
          const pkgs = bPckgs_ids.map((id) => ({ ...products[id], id }));
          const brand_packages = brand.packages;
          let brandPckgs_ids = brand_packages
            ? Object.keys(brand_packages)
            : [];
          const b_pkgs = brandPckgs_ids.map((id) => ({
            ...brand_packages[id],
            id,
          }));
          setProducts([
            ...pkgs.filter((item) => item.active),
            ...b_pkgs.filter((item) => item.active),
          ]);
        });
        Firebase.getAllTokenEarnings((tokenEarnings) => {
          // get live tasks
          let super_tokenEarnings = tokenEarnings.filter((obj) => !obj.brand);
          let brand_tokenEarnings = tokenEarnings.filter((obj) =>
            obj.brand
              ? obj.brand.toLowerCase() === brand.name.toLowerCase()
              : false
          );
          let total_tokenEarnings = super_tokenEarnings
            .concat(brand_tokenEarnings)
            .sort((a, b) =>
              a.title < b.title ? -1 : a.title > b.title ? 1 : 0
            );
          // Firebase.getAllHotTasks(brand.name, (hot_tasks) => {
          //   const result = total_tokenEarnings.filter((item) =>
          //     hot_tasks.includes(item.id)
          //   );
          //   console.log("live tasks", result);
          // });
          setLiveTasks(total_tokenEarnings);
          // setLiveTasks(tokenEarnings);
        });
      }
    } else {
      history.push("/");
    }
  }, [brand]);

  // useEffect(() => {
  //   const { title, leadMedia, leadParagraph } = article;
  //   if (title && leadMedia && leadParagraph) setIsPostable(true);
  //   else setIsPostable(false);
  // }, [article]);

  const formResets = () => {
    setEvents([]);
    setProducts([]);
    setLiveTasks([]);
    setLoading(false);
    setToMembers(true);
    setIsPublic(true);
    setToReferrals(true);
    setArticle({
      ...default_article,
      isPublic: true,
      toReferrals: true,
      toMembers: true,
    });
  };
  const handleClickClose = () => {
    dismissElement.current.click();
    formResets();
  };
  const handleClickCreate = () => {
    onAdd({ ...article, territory: territoryToPublish.value });
    dismissElement.current.click();
  };
  const handleChangeArticle = (article) => {
    const newArticle = _.cloneDeep(article);
    setArticle(newArticle);
  };
  return (
    <div
      className="modal fade"
      id="add_article_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add a new article</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={dismissElement}
              onClick={handleClickClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1 ">
            <ArticleForm
              onChangeArticle={handleChangeArticle}
              updateArticle={setArticle}
              article={article}
              events={events}
              products={products}
              liveTasks={liveTasks}
              hex={brand ? brand.hex : "#fff"}
              white={brand ? brand.white : false}
              handleLoading={(isLoading) => setLoading(isLoading)}
              toMembers={toMembers}
              setToMembers={setToMembers}
              toReferrals={toReferrals}
              setToReferrals={setToReferrals}
              isPublic={isPublic}
              setIsPublic={setIsPublic}
            />
            <div className="section-title">
              <h5>Post to certain territory</h5>
            </div>
            <div className="mb-2">
              <ReactSelect
                value={territoryToPublish}
                onChange={(value) => setTerritoryToPublish(value)}
                options={[{ label: "All", value: "All" }, ...TerritoryOptions]}
                placeholder="Select a brand territory to publish"
                isSearchable={false}
                components={{ MenuList, SingleValue }}
              />
            </div>
          </div>
          <div className="modal-footer footer-container">
            <div className="btn-action-container">
              <Fragment>
                {/* <button
                  type="button"
                  className="btn btn-orange"
                  data-dismiss="modal"
                >
                  Add Later
                </button> */}
                <button
                  type="button"
                  className="btn btn-green"
                  data-dismiss="modal"
                  disabled={
                    !(
                      article &&
                      article.title &&
                      article.leadMedia &&
                      article.leadParagraph
                    ) || loading
                  }
                  onClick={handleClickCreate}
                >
                  Create
                </button>
              </Fragment>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddArticleModal;



// WEBPACK FOOTER //
// ./src/screens/SuperArticles/components/AddArticleModal.js